<template>
  <div>
    <v-row>
      <v-col>
        <text-field-like
            v-model="processImplementation.name"
            label="プロセス名"
            hide-details>
        </text-field-like>
      </v-col>
    </v-row>
    <el-table
        :data="calendarsView"
        row-key="id">
      <el-table-column
          prop="isSelected"
          width="60"
          align="center">
        <template #default="{row}">
          <table-inline>
            <el-tooltip
                v-if="row.isExisting"
                content="作成済み">
              <v-icon color="gray" style="font-size: 17px; color: rgba(0,0,0,0.4);">mdi-checkbox-marked</v-icon>
            </el-tooltip>
            <el-checkbox
                v-else
                :value="row.isSelected"
                @change="handleCalendarSelectionChange(row, $event)"/>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          prop="name"
          label="名称"
          width="200">
      </el-table-column>

      <el-table-column
          prop="description"
          label="説明">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          label="サマリ">
        <template #default="{row}">
          {{ row.view.summary }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import {mapGetters, mapState} from "vuex";
import Formatter from "@/utils/Formatter";
import {createCalendarView} from "@/components/pages/implementation/TerminalImplementationList/CalendarView";

export default {
  name: "CalendarSelectForm",
  components: {TextFieldLike, TableInline},
  mixins: [
    Formatter
  ],
  props: {
    processImplementation: {
      type: Object,
      required: true,
    },
    existingCalendarIds: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    form: {default: null},
  },
  created() {
    this.form && this.form.register(this);
    this.$store.dispatch('hcs/calendar/findList', { q: { terminalIdEq: this.account.user?.terminal?.id } })
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
  computed: {
    ...mapState('hcs/calendar', ['calendars']),
    ...mapGetters({
      account: 'hcs/account'
    }),
    calendarsView() {
      return this.calendars.map(c => ({
        isSelected: this.value.includes(c.id),
        isExisting: this.existingCalendarIds.includes(c.id),
        view: createCalendarView(c),
        ...c
      }));
    },
    hasError() {
      return this.value.length === 0;
    },
  },
  methods: {
    handleCalendarSelectionChange(row, isSelected) {
      const selections = Array.from(this.value);
      const index = selections.findIndex(id => id === row.id);
      if (isSelected && index === -1) {
        selections.push(row.id);
        this.$emit('input', selections);
      } else if(!isSelected && index !== -1) {
        selections.splice(index, 1);
        this.$emit('input', selections);
      }
    }
  },
}
</script>

<style scoped>

</style>
